module.exports = __webpack_public_path__ + "img/event-6.08a04b28.png";